import { useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEQM1020_R01Store } from "./Store_EQM1020_R01";
import { CompanyDto } from "src/dtos/company/companyDto";

export const SearchSection_EQM1020_R01 = () => {
    const { EQM1020_R01Filter, setEQM1020_R01Filter } = useEQM1020_R01Store();
    const { compCdList } = useCommonCodeStore();

    // 달력 팝업 노출 여부 상태
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={EQM1020_R01Filter.compCd}
                optionList={compCdList}
                onChangeValue={v => setEQM1020_R01Filter({ compCd: v === 'all' ? '' : v })}
            />
            <SearchDateSingleForm
                label="조회일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={EQM1020_R01Filter.baseDate}
                onChange={(date) => setEQM1020_R01Filter({ baseDate: date })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
        </SearchSectionForm>
    );
};
